import { defineMessages } from "react-intl";
import { loyaltyTagCommonMessages } from "../common.messages";

export const loyaltyTagSectionEditMessages = defineMessages({
  ...loyaltyTagCommonMessages,
  title: {
    id: "loyaltyTagSectionEdit.title",
    defaultMessage: "Section",
  },
  preferences: {
    id: "loyaltyTagSectionEdit.preferences",
    defaultMessage: "Select preferences",
  },
  preferencesPlaceholder: {
    id: "loyaltyTagSectionEdit.preferencesPlaceholder",
    defaultMessage: "Select the desired preferences",
  },
});
